import {useFetch} from '@/hooks/useFetch';
import {env} from '@/utils/constants/env';
import {ProfileInfo} from '@/utils/types/user';
import {useMutation, useQuery} from '@tanstack/react-query';
import {AuthContext, ColumnProps, TableLowcode,} from 'alurkerja-ui';
import {omit} from 'lodash';
import React, {useContext, useEffect, useState} from 'react';
import {useCustomSpec} from "@/utils/hooks/useCustomSpec";
import PaginationCustom from '@/components/ui/PaginationCustom';
import axios from 'axios';
import { useKeycloak } from 'keycloak-react-web';

export const ListEmployee = () => {
  const axiosInstance = useContext(AuthContext);

  const [pageConfig, setPageConfig] = useState({ limit: 10, page: 0 });
  const [renderState, setRenderState] = useState(0);
  const [pagination, setPagination] = useState<any>();
  const [orderBy, setOrderBy] = useState<'asc' | 'desc' | undefined>('asc');
  const [search, setSearch] = useState<string | undefined>('');
  const [access, setAccess] = useState(false);
  const [filterBy, setFilterBy] = useState<{ [x: string]: any } | undefined>();

  const { data: profileInfo } = useFetch<ProfileInfo>({
    path: '/api/user/profile',
  });

  const { data: lastUpdateInfo } = useFetch<{
    finishDate: string;
  }>({
    path: '/api/user/last-updated',
  });

  useEffect(() => {
    console.log('lastUpdateInfo', lastUpdateInfo);
  }, [lastUpdateInfo])

  const { data, isLoading, refetch } = useQuery<any[]>({
    queryKey: [
      'user',
      `page_size=${pageConfig.limit}&page=${pageConfig.page}&asc=${orderBy === 'asc'}`,
    ],
    queryFn: async () => {
      return axiosInstance
        .get(
          `/api/user/list?limit=${pageConfig.limit}&page=${pageConfig.page}&asc=${orderBy === 'asc'}`,
        )
        .then(res => {
          if (res.status === 200) {
            setPagination(omit(res.data.data, ['content']));
            return res.data.data.content;
          }
        });
    },
  });

  const columns: ColumnProps = [
    { key: 'fullname', label: 'Employee Name' },
    { key: 'email', label: 'Work Email' },
    { key: 'telp', label: 'Work Phone' },
    { key: 'department', label: 'Department' },
    { key: 'role', label: 'Job Position' },
    { key: 'manager', label: 'Manager' },
  ];

  const customSpec = useCustomSpec('', {
    columns,
  });

  const CustomHeader = () => {
    const { keycloak } = useKeycloak();
    const { mutate, isLoading } = useMutation({
      mutationFn: async () => {
        const response = await axios.get(`${env.apiBaseUrl}/api/v1/freeipa/syncs`, {
          headers: {
            Authorization: `Bearer ${keycloak.token}`,
          },
        });
        return response.data;
      },
      onSuccess: (res) => {
        if (res.message) {
          refetch();
        }
      },
      onError: (error: any) => {
        console.error('Error syncing user:', error);
      },
    });

    const handleSyncClick = () => {
      mutate();
    };

    return (
      <div>
        <div className="py-4 border-b">
          <div className="px-7 flex flex-row items-center justify-between gap-2" id="table_header" data-testid="table_header">
            <h5 className="mb-0 mr-4 font-bold uppercase" id="table_title" data-testid="table_title">Data User</h5>
            <div className="flex flex-row items-center gap-2">
              <button
                disabled={isLoading}
                id="button-create"
                className="bg-yellow-400 text-black p-2 rounded"
                onClick={handleSyncClick}>
                <div className="flex items-center gap-0.5">
                  {isLoading ? 'Synchronizing...' : 'Synchronize User'}
                </div>
              </button>
            </div>
          </div>

          <div
            className="justify-end flex items-center"
          >
            <p className="text-sm text-gray-500 px-7 mt-2">
              Last Updated: {lastUpdateInfo?.finishDate ? new Date(lastUpdateInfo.finishDate).toLocaleString() : 'N/A'}
            </p>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    setAccess(true);
  }, [profileInfo]);

  return (
    <div>
      {access && (
        <div>
          <TableLowcode
            hideActionColumn={true}
            title="Data User"
            baseUrl={env.apiBaseUrl}
            data={data}
            isLoadingData={isLoading}
            spec={customSpec}
            filterBy={filterBy}
            setFilterBy={setFilterBy}
            search={search}
            setSearch={setSearch}
            renderState={renderState}
            setRenderState={setRenderState}
            pageConfig={pageConfig}
            setPageConfig={setPageConfig}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            customHeader={CustomHeader}
            customPagination={() => <PaginationCustom pagination={pagination} pageConfig={pageConfig} setPageConfig={setPageConfig} />}
          />
        </div>
      )}
    </div>
  );
};
